<template>
  <div class="text-gray-600 privacy-statement-component">
    <div class="lg:flex">
      <p class="privacy-statement-component-subject-title ota-subtitle pb-12 pr-10 lg:pt-4" v-html="$t('PrivacyStatement.General.Subjects')" />
      <div class="mb-10 flex-1 flex justify-end">
        <div class="right-flex w-full">
          <ProductAccordion
            v-for="(contentBlock, index) in content"
            :key="`${contentBlock.Question}-${index}`"
            class="mt-5 border-b"
          >
            <template v-slot:trigger>
              {{ contentBlock.Question }}
            </template>
            <template v-slot:content>
              <div class="ota-small-light pb-5 md:pb-10" v-html="contentBlock.Answer" />
            </template>
          </ProductAccordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductAccordion from '@/components/Webshop/ProductAccordion'

export default {
  name: 'PrivacyStatementComponent', // name clash
  components: {
    ProductAccordion
  },
  computed: {
    content () {
      const questions = this.$t('PrivacyStatement.Content.Questions')

      const variables = {
        customerioLink: '<a class="italic underline" href="https://customer.io/legal/privacy-policy">https://customer.io/legal/privacy-policy</a>',
        postnlLink: '<a class="italic underline" href="https://www.postnl.nl/en/privacy-statement/">https://www.postnl.nl/en/privacy-statement/</a>'
      }

      return questions
        .map((content, index) => ({ content, index }))
        .filter(({ content }) => content && content.Answer && content.Question)
        .map(({ index }) => ({
          Answer: this.$t(`PrivacyStatement.Content.Questions[${index}].Answer`, variables),
          Question: this.$t(`PrivacyStatement.Content.Questions[${index}].Question`, variables)
        }))
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-accordion {
  >>> b {
    @apply font-extrabold;
  }

  >>> .ota-p18 {
    font-size: 1.5rem;
  }
}

.right-flex {
  max-width: 75rem;
}
</style>
